export default __webpack_public_path__ + "static/media/headset.319d2310.svg";